import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* Pseudonyme Besucherzählung der öffentlichen Seiten: ein Beacon je Seitenwechsel, keine Cookies, kein Speicher im Browser.
   Kundenbereich/App/Admin zählt der Server ohnehin nicht (PRIVAT_RE in besucher_stats.py). */
const PRIVAT = /^\/(app|portal|admin|kunden|baukasten|l\/|t\/|einlass)(\/|$)/;

export const BesuchZaehler = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || PRIVAT.test(pathname) || navigator.webdriver) return;
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/stats/besuch`;
    const body = JSON.stringify({ pfad: pathname });
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
      else fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
    } catch { /* Zählung ist optional */ }
  }, [pathname]);
  return null;
};
